import { API_BASE_URL } from '@synergy/config';
import { createAction } from '@reduxjs/toolkit';

import { AppDispatch, AppState } from '../../store/store';
import { ChangePasswordFormValues } from '../pages/modals/change-password/models/change-password-form-values';
import { PoolSnackbar } from '../components/snackbars/pool-snackbar';
import { changePasswordApi } from '../api/change-password-api';
import { enqueueSnackbar } from './snackbar-actions';

const api = new changePasswordApi(API_BASE_URL);

export const openChangePasswordModal = createAction('change-password/open-modal');
export const closeChangePasswordModal = createAction('change-password/close-modal');
export const changePasswordError = createAction('change-password/error');
export const changePasswordSubmit = createAction('change-password/submit');

export const changePassword =
    (values: ChangePasswordFormValues) => async (dispatch: AppDispatch, _getState: () => AppState) => {
        dispatch(changePasswordSubmit());
        const response = await api.changePassword(values.currentPassword, values.newPassword);
        if (response.success) {
            dispatch(enqueueSnackbar(PoolSnackbar.success('app.changePassword.changed')));
            dispatch(closeChangePasswordModal());
        } else {
            if (response.errorCode === 400) {
                dispatch(changePasswordError());
            } else {
                dispatch(enqueueSnackbar(PoolSnackbar.error('app.error.general')));
            }
        }
    };
